import React, { useEffect, useState } from 'react';
import { SelectMultiple } from 'tea-component';
import { useIntl } from 'umi';

const retentionOptions = ['D2', 'D3', 'D7', 'D15', 'D31'].map((_text, idx) => ({
  value: _text,
  text: _text,
}));
export default function RetentionSelector(props: any) {
  const { value: defaultValue, onConfirm, defaultValue: defaultValueProps } = props;
  const [retentionVal, setRetentionVal] = useState<string[]>(defaultValue || defaultValueProps?.value || []);

  const { formatMessage } = useIntl();
  const [updateValue, setUpdateValue] = useState(false);
  useEffect(() => {
    setRetentionVal(defaultValue || defaultValueProps?.value || [])
  }, [defaultValue])

  return (
    <SelectMultiple
      className="select-item"
      size="m"
      staging={false} //不渲染确定和取消按钮
      appearance="button"
      matchButtonWidth
      listHeight={300}
      button={
        <>
          <div className="dbi-select-button">
            <span className="select-button-text">
              {formatMessage({ id: 'dbi_retention' })}
            </span>
            {retentionVal?.length === retentionOptions?.length ? (
              'All'
            ) : (
              <span className="select-button-desc">
                {retentionVal?.map((item, idx) => {
                  if (retentionVal?.length - 1 === idx) {
                    return (
                      <span className="select-button-desc" key={idx}>
                        {item}
                      </span>
                    );
                  }
                  return (
                    <span className="select-button-desc" key={idx}>
                      {item},{' '}
                    </span>
                  );
                })}
              </span>
            )}
          </div>
        </>
      }
      value={retentionVal}
      onChange={(value) => {
        setUpdateValue(true);
        //标签顺序还要按D2 D3 D7顺序展示 而不是D3 D7 D2
        value.sort((a, b) => {
          let _a = a?.slice(1);
          let _b = b?.slice(1);
          return parseInt(_a) - parseInt(_b);
        });
        setRetentionVal(value);
      }}
      options={retentionOptions}
      allOption={{
        value: 'all',
        text: 'All',
      }}
      onClose={() => {
        if (!updateValue) {
          return
        }
        const newValue = !retentionVal?.length ? defaultValue?.value : retentionVal;
        setRetentionVal(newValue)
        if (onConfirm instanceof Function) {
          onConfirm(newValue);
        }
        setUpdateValue(false);
      }}
    />
  );
}
